import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=f6afc5ce&"
import script from "./PageTable.vue?vue&type=script&lang=js&"
export * from "./PageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports